export default "__VITE_ASSET__DAQapRvK__"